import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const AddTaskDetails = React.lazy(() => import("./AddTaskDetails"));
const Project = React.lazy(() => import("./CreateProject"));
export const ProjectConfigs = [
  {
    permittedRole: [
      RoutePermittedRole.FRONTDESK,
      RoutePermittedRole.MANAGER,
      RoutePermittedRole.ADMIN,
      RoutePermittedRole.SUPER_ADMIN,
      RoutePermittedRole.MEMBER,
      RoutePermittedRole.DOCTOR,
      RoutePermittedRole.FINANCE_MANAGER,
      RoutePermittedRole.HR_MANAGER,
    ],
    path: "/performance/project/:id",
    element: <AddTaskDetails />,
  },
  {
    permittedRole: [
      RoutePermittedRole.FRONTDESK,
      RoutePermittedRole.MANAGER,
      RoutePermittedRole.ADMIN,
      RoutePermittedRole.SUPER_ADMIN,
      RoutePermittedRole.MEMBER,
      RoutePermittedRole.DOCTOR,
      RoutePermittedRole.FINANCE_MANAGER,
      RoutePermittedRole.HR_MANAGER,
    ],
    path: "/performance/project",
    element: <Project />,
  },
];
